import { Modal, Header, Button, Input, Checkbox, Form, Dropdown, Message } from 'semantic-ui-react';

function EditUser({ current_user, project_options, updateCurrentUser, open, handleClose, handleSaveUser, saving, error_message }) {
	const action_text  = current_user.id ? `Save` : `Add`;
	const modal_header = `${action_text} User`;

	return (
		<Modal
			size="small"
			closeIcon
			open={open}
			onClose={handleClose}
		>
			<Header content={modal_header} />

			<Modal.Content>
				{error_message &&
					<Message negative>{error_message}</Message>
				}

				{!current_user.id &&
					<Message info>Upon adding the user they will receive an email asking them to confirm their account.</Message>
				}
				<Form>
					<Form.Field>
						<label>First Name</label>
						<Input fluid focus placeholder="First name" name="first_name" value={current_user.first_name} onChange={(e) => updateCurrentUser(e)} />
					</Form.Field>

					<Form.Field>

						<label>Last Name</label>
						<Input fluid focus placeholder="Last name" name="last_name" value={current_user.last_name} onChange={(e) => updateCurrentUser(e)} />
					</Form.Field>

					<Form.Field>
						<label>Email</label>
						<Input fluid focus placeholder="Email" name="email" value={current_user.email} onChange={(e) => updateCurrentUser(e)} />
					</Form.Field>

					<Form.Field>
						<label>Projects</label>
						<Dropdown
							name="projects"
							placeholder="Projects"
							fluid
							multiple
							selection
							value={current_user.project_ids ? current_user.project_ids : []}
							options={project_options}
							onChange={updateCurrentUser}
						/>
					</Form.Field>

					<Form.Field>
						<label>Admin</label>
						<Checkbox name="admin" checked={!!current_user.admin} onChange={(e, data) => updateCurrentUser(e, data)} />
					</Form.Field>

					{current_user.id &&
						<Form.Field>
							<label>Active</label>
							<Checkbox name="active" checked={!!current_user.active} onChange={(e, data) => updateCurrentUser(e, data)} />
						</Form.Field>
					}
				</Form>
			</Modal.Content>

			<Modal.Actions>
				<Button color="red" onClick={handleClose}>Cancel</Button>
				<Button color="green" loading={saving} onClick={handleSaveUser}>{action_text}</Button>
			</Modal.Actions>
		</Modal>
	);
}

export default EditUser;
